"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.chat.nomodel': 'Selecciona un modelo para empezar a chatear',
};
